import React, { useState, useEffect } from "react"
import { AuthorizableLink } from '@reactiveonline/frontend_shared_components'

import MiniCart from "./MiniCart"

export default function HeaderIcons({ appProps }) {
  const [selectedDropMenu, setSelectedDropMenu] = useState(null)
  const [openMenu, setOpenMenu] = useState(false)

  const localePrefix = appProps.currentLocale ? `/${appProps.currentLocale}` : ''
  const { translations, registrationEnabled } = appProps
  const profileData = [
    { title: translations.account.manage_account, icon: 'fa-user',          read: false, timestamp: null, path: appProps.accountPath },
    { title: translations.account.reservation_history,  icon: 'fa-list-radio',    read: false, timestamp: null, path: appProps.reservationsPath },
    { title: translations.account.billing,        icon: 'fa-address-book',  read: false, timestamp: null, path: appProps.billingPath },
    { title: translations.account.privacy_policy, icon: 'fa-shield-halved', read: false, timestamp: null, path: appProps.privacyPolicyPath },
    { title: translations.account.delete_account, icon: 'fa-eraser',        read: false, timestamp: null, path: appProps.deleteAccountPath },
    { title: translations.general.logout,         icon: 'fa-right-from-bracket', read: false, timestamp: null, path: appProps.logoutPath, requestType: 'delete' },
  ]

  let loginData = [{ title: translations.account.login_button, icon: null, read: false, timestamp: null, path: `${localePrefix}/account` }]

  if(registrationEnabled) {
    loginData.push({ title: translations.account.register_button, icon: null, read: false, timestamp: null, path: `${localePrefix}/account` })
  }

  function escFunction(event){
    if (event.key === "Escape") {
      setOpenMenu(false)
    }
  }

  useEffect( ()=>{
    document.addEventListener("keydown", escFunction, false);
  },[openMenu])

  return (
    <div className="header-icons-container">
      <ul>
        { appProps.currentReservationPath &&
          <li className="cart-dropmenu mini_cart">
            <div id="mini-cart-ajax-container">
              <MiniCart
                appProps={ appProps }
              />
            </div>
          </li>
        }
        <li className="account">
          <AuthorizableLink
            appProps={ appProps }
            profileData={ profileData }
            linkClass="account_icon my-account"
            linkRef={ appProps.accountPath }
          />
        </li>
      </ul>
    </div>
  )
}
